import LBox from "@components/LBox";
import LIcon, { LIconProps } from "@components/LIcon";
import LText, { Props as LTextProps } from "@components/LText";
import { theme } from "@theme";
import { LBoxProps } from "@components/LBox";

type LocationProps = {
  city: string;
  country: string;
  venue?: string | null;
  boxProps?: LBoxProps;
  iconProps?: Partial<LIconProps>;
  textProps?: Omit<LTextProps, "children">;
};

const Location = ({
  city,
  country,
  venue,
  boxProps,
  iconProps,
  textProps,
}: LocationProps) => {
  // converger-created events (radio episodes) can have all three empty.
  const region = [city, country].filter(Boolean).join(", ");
  const locationText = venue
    ? region
      ? `${venue} (${region})`
      : venue
    : [city, country].filter(Boolean).join(" • ");

  return (
    <LBox flexDirection="row" alignItems="center" gap="s1_5" {...boxProps}>
      <LIcon
        colors={{ color: theme.colors.lightGrey }}
        name="location_pin"
        size={14}
        {...iconProps}
      />
      <LText variant="Body/B1/Medium" color="lightGrey" {...textProps}>
        {locationText}
      </LText>
    </LBox>
  );
};

export default Location;
